import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { PulumiConfiguration } from '../models/PulumiConfiguration';
import { UpdatePulumiConfigurationRequest } from '../models/UpdatePulumiConfigurationRequest';

/**
 * no description
 */
export class UpdatePulumiConfigurationApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Update Pulumi configuration by id
   * @param id 
   * @param updatePulumiConfigurationRequest 
   */
  public async updatePulumiConfiguration(id: string, updatePulumiConfigurationRequest: UpdatePulumiConfigurationRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("UpdatePulumiConfigurationApi", "updatePulumiConfiguration", "id");
    }


    // verify required parameter 'updatePulumiConfigurationRequest' is not null or undefined
    if (updatePulumiConfigurationRequest === null || updatePulumiConfigurationRequest === undefined) {
      throw new RequiredError("UpdatePulumiConfigurationApi", "updatePulumiConfiguration", "updatePulumiConfigurationRequest");
    }


    // Path Params
    const localVarPath = '/pulumi-configurations/{id}'
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(updatePulumiConfigurationRequest, "UpdatePulumiConfigurationRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class UpdatePulumiConfigurationApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to updatePulumiConfiguration
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async updatePulumiConfigurationWithHttpInfo(response: ResponseContext): Promise<HttpInfo<PulumiConfiguration >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: PulumiConfiguration = ObjectSerializer.deserialize(
        await response.body.json(),
        "PulumiConfiguration", ""
      ) as PulumiConfiguration;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: PulumiConfiguration = await response.body.json() as PulumiConfiguration;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
